import type { RouteRecordRaw } from 'vue-router'

const microfinanceRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/app/layout-app.vue'),
    children: [
      {
        path: 'simpanan',
        children: [
          {
            path: '',
            name: 'saving list',
            component: () => import('@/views/microfinance/saving/list/page-saving-list.vue'),
          },
          {
            path: 'simpanan-pengguna/:user_id',
            name: 'saving user detail',
            component: () => import('@/views/microfinance/saving/detail/page-saving-user-detail.vue'),
          },
          {
            path: 'jenis-simpanan',
            name: 'saving type list',
            component: () => import('@/views/microfinance/saving-type/list/page-saving-type-list.vue'),
          },
        ],
      },
      {
        path: 'pinjaman-pengguna/:user_id',
        name: 'loan user detail',
        component: () => import('@/views/microfinance/loan/detail/page-loan-user-detail.vue'),
      },
      {
        path: 'pembelian-pengguna/:user_id',
        name: 'sale user detail',
        component: () => import('@/views/shop/sale/detail/page-sale-user-detail.vue'),
      },
      {
        path: 'pinjaman',
        children: [
          {
            path: '',
            name: 'loan list',
            component: () => import('@/views/microfinance/loan/list/page-loan-list.vue'),
          },
          {
            path: ':id',
            name: 'loan detail',
            component: () => import('@/views/microfinance/loan/detail/page-loan-detail.vue'),
          },
          {
            path: 'jenis-pinjaman',
            name: 'loan type list',
            component: () => import('@/views/microfinance/loan-type/list/page-loan-type-list.vue'),
          },
          {
            path: 'pembayaran',
            name: 'loan payment list',
            component: () => import('@/views/microfinance/loan-payment/list/page-loan-payment-list.vue'),
          },
          {
            path: 'pembayaran/:id',
            name: 'loan payment detail',
            component: () => import('@/views/microfinance/loan-payment/detail/page-loan-payment-detail.vue'),
          },
          {
            path: 'topup',
            name: 'loan topup list',
            component: () => import('@/views/microfinance/loan-topup/list/page-loan-topup-list.vue'),
          },
          {
            path: 'topup/:id',
            name: 'loan topup detail',
            component: () => import('@/views/microfinance/loan-topup/detail/page-loan-topup-detail.vue'),
          },
        ],
      },
      {
        path: 'simpananku',
        name: 'saving my',
        component: () => import('@/views/microfinance/saving/list/page-saving-my.vue'),
      },
      {
        path: 'pinjamanku',
        name: 'loan my',
        component: () => import('@/views/microfinance/loan/list/page-loan-my.vue'),
      },
      {
        path: 'simulasi-pinjaman',
        name: 'admin loan simulation',
        component: () => import('@/views/microfinance/loan-simulation/page-loan-simulation.vue'),
      },
    ],
  },
]

export { microfinanceRoutes }
